import { CUSTOM, GLOBAL } from "../constants/used-by-status";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { Translator } from "../contexts/translator";

export const usedByStatus = (status, translate: Translator) => {
    if (status === GLOBAL) {
        return translate.byKey(TranslationKeys.assignedToAll);
    }
    else if (status === CUSTOM) {
        return translate.byKey(TranslationKeys.custom);
    }
    else {
        return '';
    }
}
